<bds-scroll-region [maxHeight]="maxHeight" [ariaLabel]="ariaLabel()">
  <div class="bn-care-plan-card-list">
    <ng-content />
  </div>
</bds-scroll-region>
